import { useEffect, useRef } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get('session_id');
    axios
      .post(`${API}/auth/session`, { session_id: sessionId })
      .then((res) => navigate('/admin', { replace: true, state: { user: res.data } }))
      .catch((err) => navigate('/admin', { replace: true, state: { denied: err.response?.status === 403 } }));
  }, [location.hash, navigate]);

  return null;
};

export default AuthCallback;
